// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__dXiCI","open":"styles_open__13H8h","input":"styles_input__NBzcT","close":"styles_close__38JYW"};